<template>
  <div class="v-modal">
    <div class="v-modal__header">
      <span>Country Selection</span>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="v-modal__body">
      <multiselect
        ref="vms"
        v-model="value"
        placeholder="Country name"
        label="name"
        track-by="countryID"
        :options="options"
        :close-on-select="false"
        :multiple="true"
      ></multiselect>
    </div>
    <div class="v-modal__footer">
      <button class="button" @click="close()">Ok</button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { assessment } from "@/services/assessment-model.js";
import { countries } from '@/services/entity-model.js'
import _ from "lodash";

export default {
  name: "Country",
  components: {
    Multiselect
  },
  async mounted() {
    this.options = countries || [];
    this.value = _.cloneDeep(assessment.countriesOrBasins);
    this.$refs.vms.$el.focus();
  },
  data() {
    return {
      value: [],
      options: []
    };
  },
  methods: {
    close: function() {
      assessment.countriesOrBasins = Object.assign([], this.value);
      assessment.nextStep();
    }
  }
};
</script>
